// PostHog product analytics (EU Cloud, project "Rafiki"): who comes back, where players drop out,
// whether Daily Rafiki brings them back. Same rule as Google Analytics (analytics.ts): nothing is
// downloaded or sent until the visitor consents, it stops on refusal, and portals, Discord and
// local mode never start it. The library is loaded on demand, so it costs nothing on first load.
import { getLang } from "./i18n";
import { isEmbedded } from "./portal";
import { isLocalMode } from "./localStore";
import { loadPosthog } from "./posthogLoader";

// The project's public key: write-only, made to sit in browser code.
export const POSTHOG_KEY = "phc_xpiMLNFzoVK5jsCPBoYapbi6jhHZocs8YSHWAMmtVAmt";
export const POSTHOG_HOST = "https://eu.i.posthog.com";

let ph: any = null;
let loading: Promise<any> | null = null;
let consented = false;
const queued: { name: string; params: any }[] = [];

const start = () => {
  if (loading) return loading;
  loading = loadPosthog()
    .then((m) => {
      const p = m.default;
      p.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        person_profiles: "always",
        capture_pageview: "history_change",
        capture_pageleave: true,
        autocapture: false,
        disable_session_recording: true,
        disable_surveys: true,
        advanced_disable_flags: true,
        persistence: "localStorage+cookie",
        ip: false,
      });
      p.register({ lang: getLang(), app: "website" });
      ph = p;
      if (!consented) p.opt_out_capturing();
      while (queued.length) {
        const item = queued.shift() as { name: string; params: any };
        const n = item.name;
        const params = item.params;
        if (consented) p.capture(n, params);
      }
      return p;
    })
    .catch((e) => {
      try {
        console.warn("analytics (PostHog) did not start", e);
      } catch (x) {}
      return null;
    });
  return loading;
};

export const setPosthogConsent = (granted: boolean) => {
  if (isLocalMode || isEmbedded) return;
  consented = granted;
  if (granted) {
    if (ph) ph.opt_in_capturing();
    else start();
  } else if (ph) {
    try {
      ph.opt_out_capturing();
    } catch (e) {}
  }
};

export const posthogCapture = (name: string, params?: any) => {
  if (!consented) return;
  if (ph) {
    try {
      ph.register({ lang: getLang() });
      ph.capture(name, params);
    } catch (e) {}
  } else if (queued.length < 50) queued.push({ name, params });
};

// Tests only.
export const _resetPosthogForTests = () => {
  ph = null;
  loading = null;
  consented = false;
  queued.length = 0;
};
